import { render } from "./NetworkError.vue?vue&type=template&id=071e8106"
import script from "./NetworkError.vue?vue&type=script&lang=js"
export * from "./NetworkError.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__